<template>
  <i-badge
    class="signal-chip"
    :colour="iBadgeColours.ERROR"
    icon="small-alert-triangle"
    :has-leading-icon="true"
    :label="title"
    :interactable="true"
  ></i-badge>
</template>

<script>
import { iBadge, iBadgeColours } from '@inscribe/signal';
import signalConfig from '@/constants/signalConfig';
import humanizeString from 'humanize-string';

export default {
  components: { iBadge },
  props: {
    signal: {
      type: Object,
      default: null,
    },
  },
  data() {
    return { iBadgeColours };
  },
  computed: {
    signalConfigObj() {
      return (
        signalConfig[this.signal.signalName] || {
          title: humanizeString(this.signal.signalName),
          icon: 'list',
        }
      );
    },
    title() {
      const { getTitle = () => this.signalConfigObj.title } =
        this.signalConfigObj;
      return getTitle(this.signal);
    },
  },
};
</script>
